import React, {Component} from "react";
import {
    PAGES
} from "../../../scripts/constants";
import {Container, Row, Button, Spinner, Col} from "react-bootstrap";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {processBlinkId, processCombinedId ,getDisplayForIdType, getDisplayForRecognitionStatus} from "../../../scripts/microblink";
import "./IdScan.css";
import Webcam from "react-webcam";
import {mygaSession} from "../../../scripts/myga-session"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Resources from "../../../Resources/Resources";
import {idScan} from "../../../scripts/sync-manager";
import {NassauLog} from "../../../scripts/myga-utils";
import {Analytics} from "../../../scripts/analytics";
import {GTM_EVENT, GTM_VARIABLE} from "../../../scripts/analytics-gtm";

let SCAN_MODES = Object.freeze({
    SCAN_FRONT: 'SCAN_FRONT',
    PREVIEW_FRONT: 'PREVIEW_FRONT',
    CONFIRM_INFO: 'CONFIRM_INFO'
});

class IdScan extends Component {

    constructor(props) {
        super(props);

        this.camera = React.createRef();

        this.state = {
            errorMessage: '',
            scanMode: SCAN_MODES.SCAN_FRONT,
            base64ImageFront: null,
            submitBusy: false,
            scanResult: null
        };

    }

    // //When the image is loaded, we convert to base64 for uploading
    // imageLoaded = (scanMode) => {
    //
    //     switch (scanMode) {
    //         case SCAN_MODES.PREVIEW_FRONT:
    //             this.setState({
    //                 base64ImageFront : this.imgToBase64('preview-image')
    //             })
    //             break;
    //         default:
    //             break;
    //
    //     }
    //
    // }


    // //Not is use anymore.
    // imgToBase64 = (imgId) => {
    //
    //     let c = document.createElement('canvas');
    //     let img = document.getElementById(imgId);
    //     c.height = img.naturalHeight;
    //     c.width = img.naturalWidth;
    //     let ctx = c.getContext('2d');
    //
    //     ctx.drawImage(img, 0, 0, c.width, c.height);
    //     return c.toDataURL();
    // }

    handleTakePhotoFront = () => {

        let base64Image = this.camera.current.getScreenshot();
        //NassauLog("Took Picture Front:"+base64Image);

        this.setState({
            base64ImageFront: base64Image,
            scanMode: SCAN_MODES.PREVIEW_FRONT,
        });

    };

    acceptPhotoFront = () => {

        this.submitID();

    };

    retakePhotoFront = () => {

        //this will remove all current scan related data
        this.setState({
            base64ImageFront: null,
            scanMode: SCAN_MODES.SCAN_FRONT
        });

    };

    resetScanProcess = () => {

        //this will remove all current scan related data
        this.setState({
            base64ImageFront: null,
            scanMode: SCAN_MODES.SCAN_FRONT,
            submitBusy: false,
            scanResult: null
        });

    };

    submitID = () => {

        this.setState({
            submitBusy: true
        });
        
        // 2021.05.21.ADivelbiss - Added gtm event for id scan start
        Analytics.fireIdScanStarted();

        //Need to swap out with proxy call idscan, then remove microblink.js
        idScan(this.state.base64ImageFront)
            .then((json) => {
                NassauLog("success:"+ json);
    
                // 2021.05.21.ADivelbiss - Added gtm event for id scan finished
                Analytics.setIdScanStatus("success");
                Analytics.fireIdScanFinished();
                
                this.setState({
                    scanResult: json,
                    scanMode: SCAN_MODES.CONFIRM_INFO,
                })

            })
            .catch((err) => {
                NassauLog(err);
    
                // 2021.05.21.ADivelbiss - Added gtm event for id scan finished
                Analytics.setIdScanStatus("error");
                Analytics.fireIdScanFinished();
    
                this.setState({
                    scanResult: null,
                    errorMessage: err.description
                })
                }
            ).finally(() => {

                this.setState({
                    submitBusy: false
            });

        })
    };

    //Apply Data to Current Application
    applyScanResult = async () => {

        await mygaSession.setInfoFromScanResult(this.state.scanResult);

        this.props.updatePage(PAGES.pageAppIdDataEntry);

    };

     videoConstraints = {
          //width: 1920,
          //height: 1080,
         facingMode: "environment"
    };

    render() {

        return (

            <AppContentWrapper
                updatePage={this.props.updatePage}
                errorMessage={this.state.errorMessage}
            >

                {
                    //Scan Front Side
                    (this.state.scanMode === SCAN_MODES.SCAN_FRONT) &&

                    <Container className={'preview-card'}>
                        <Row className={'text-center'}>
                            <Col sm={11}>Place the FRONT SIDE of the document</Col>
                        </Row>
                        <Row sm={11}
                             className={'camera-container'}>
                            <div
                                className="camera-focus"
                                style={{
                                    borderColor: '#00CC00',
                                    width: '85%',
                                    height: '70%',
                                }}
                            />
                            <Webcam
                                audio={false}
                                ref={this.camera}
                                videoConstraints={this.videoConstraints}
                                screenshotFormat="image/png"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                }}

                            />
                            <Button variant={'primary'}
                                    className={'btn-circle'}
                                    onClick={this.handleTakePhotoFront}>
                                <FontAwesomeIcon icon={Resources.Icons.Camera}/>
                            </Button>

                        </Row>
                    </Container>
                }

                {
                    //Preview Front Scan Image
                    (this.state.scanMode === SCAN_MODES.PREVIEW_FRONT) &&

                    <Container>
                        <Row className={"preview-buttons"}>
                            <div className={"col-6 text-center"}>
                                <Button variant={'primary'} className={'nsre-button'}
                                        style={{minWidth: '109px'}}
                                        onClick={() => this.acceptPhotoFront()}>
                                    <span>Submit</span>
                                </Button>
                            </div>
                            <div className={"col-6 text-center"}>
                                <Button variant={'secondary'} className={'nsre-button'}
                                        style={{minWidth: '109px'}}
                                        onClick={() => this.retakePhotoFront()}>
                                    <span>Retake</span>
                                </Button>
                            </div>

                        </Row>
                        <Row className={'pb-1 text-center'}>
                            <img id={'preview-image'}
                                 className={'align-center'}
                                 src={this.state.base64ImageFront}
                                 // onLoad={() => this.imageLoaded(SCAN_MODES.SCAN_FRONT)}
                                 width={'100%'}
                            />
                        </Row>

                    </Container>

                }

                {
                    (this.state.scanMode === SCAN_MODES.CONFIRM_INFO && this.state.scanResult.result) &&

                    <Container className={'p-1'}>
                        <Row className={'pb-2'}>
                            <Col sm={6}>
                                <b>{'Scan Result: '}</b>{this.state.scanResult.result.processingStatus}
                            </Col>
                            <Col sm={6}>
                                <b>{'Recognition: '}</b>{getDisplayForRecognitionStatus(this.state.scanResult.result.recognitionStatus)}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6}>
                                <b>{'First Name: '}</b>{this.state.scanResult.result.firstName}
                            </Col>
                            <Col sm={6}>
                                <b>{'Last Name: '}</b>{this.state.scanResult.result.lastName}
                            </Col>
                        </Row>
                        <Row className={'pb-2'}>
                            <Col sm={6}>
                                <b>{'Gender: '}</b>{this.state.scanResult.result.sex === "M" ? "Male" : "Female"}
                            </Col>
                            <Col sm={6}>
                                <b>{'Date Of Birth: '}</b>{this.state.scanResult.result.dateOfBirth.originalString}
                            </Col>
                        </Row>
                        <Row className={'pb-2'}>
                            <Col sm={11}>
                                <b>{'Address: '}</b>{this.state.scanResult.result.address}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={4}>
                                <b>{'ID Type: '}</b>{getDisplayForIdType(this.state.scanResult.result.classInfo.type)}
                            </Col>
                            <Col sm={4}>
                                <b>{'Number: '}</b>{this.state.scanResult.result.documentNumber}
                            </Col>
                            <Col sm={4}>
                                <b>{'Region: '}</b>{this.state.scanResult.result.classInfo.region}
                            </Col>
                        </Row>
                        <Row className={'pb-2'}>
                            <Col sm={6}>
                                <b>{'Issued On: '}</b>{this.state.scanResult.result.dateOfIssue.originalString}
                            </Col>
                            <Col sm={6}>
                                <b>{'Expires On: '}</b>{this.state.scanResult.result.dateOfExpiry.originalString}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={11} className={'p-1 disclaimer text-center'}>
                                You will have an opportunity to modify this information on the next screen
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6} className={"text-center"}>
                                <Button variant={'primary'} className={'nsre-button'}
                                        style={{minWidth: '109px'}}
                                        onClick={() => this.applyScanResult()}>
                                    <span>Process Info</span>
                                </Button>
                            </Col>
                            <Col sm={6} className={"text-center"}>
                                <Button variant={'primary'} className={'nsre-button'}
                                        style={{minWidth: '109px'}}
                                        onClick={() => this.resetScanProcess()}>
                                    <span>Reset</span>
                                </Button>
                            </Col>
                        </Row>
                    </Container>

                }

            </AppContentWrapper>
        );

    }
}


export default IdScan;

/*

"result":{
---"dateOfBirth":{
"day":17,
"month":8,
"year":1977,
"successfullyParsed":true,
---"originalString":"08/17/1977"
},
"classInfo":{
"country":"COUNTRY_USA",
"region":"REGION_CONNECTICUT",
---"type":"TYPE_DL",
"countryName":"UNITED STATES OF AMERICA",
"isoAlpha3CountryCode":"USA",
"isoAlpha2CountryCode":"US",
"isoNumericCountryCode":"840"
},
"type":"BLINK_ID",
"isBelowAgeLimit":false,
"age":43,
---"recognitionStatus":"VALID",
---"firstName":"RESHAT,2ND",
---"lastName":"HASANKOLLI",
"fullName":"",
---"address":"102 WAVERLY ST\nWATERBURY, CT 06710-1021",
---"dateOfIssue":{
"day":4,
"month":9,
"year":2019,
"successfullyParsed":true,
---"originalString":"09/04/2019"
},
---"dateOfExpiry":{
"day":17,
"month":8,
"year":2025,
"successfullyParsed":true,
---"originalString":"08/17/2025"
},
---"documentNumber":"087520313",
---"sex":"M",
"driverLicenseDetailedInfo":{
"restrictions":"NONE",
"endorsements":"NONE",
"vehicleClass":"D",
"conditions":""
},

 */